<template>
  <div class="commission-amount">
    <h2 class="text-center">{{$t('title')}}</h2>
    <p class="little-title">{{$t('secTitle')}}</p>

    <div class="amount-list-pc" v-if="amountList">
      <ul class="amount-list">
        <li class="list-header">
          <div>{{$t('deviceNum')}}</div>
          <div>{{$t('month1')}}</div>
          <div>{{$t('month3')}}</div>
          <div>{{$t('month12')}}</div>
        </li>
        <li v-for="(deviceNum, pIndex) in deviceNumList" :key="'device-' + pIndex">
          <div class="device-number"><span>{{deviceNum}}</span></div>
          <div class="amount" v-for="(amount, cIndex) in amountList[pIndex]" :key="'device-' + pIndex + cIndex">
            <span>{{amount[0]}}</span><span></span><span>{{amount[1]}}</span>
          </div>
        </li>
      </ul>
      <div class="legend">
        <div class="first-purchase">{{$t('firstPopup')}}</div>
        <div class="renew">{{$t('renew')}}</div>
      </div>
    </div>

    <div class="amount-list-h5" v-if="amountList">
      <div class="legend">
        <div class="first-purchase">{{$t('firstPopup')}}</div>
        <div class="renew">{{$t('renew')}}</div>
      </div>
      <ul class="amount-list" v-for="(type, tIdx) in monthTypeList" :key="'type-' + tIdx">
        <li class="list-header">
          <div>{{$t('deviceNum')}}</div>
          <div>{{type === 1 ? $t('month1') : type === 3 ? $t('month3') : $t('month12')}}</div>
        </li>
        <li v-for="(device, dIdx) in deviceNumList" :key="'type-' + tIdx + dIdx">
          <div class="device-number"><span>{{device}}</span></div>
          <div class="amount">
            <span>{{amountList[dIdx][tIdx][0]}}</span><span></span><span>{{amountList[dIdx][tIdx][1]}}</span>
          </div>
        </li>
      </ul>
    </div>
    <slot></slot>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import locales from './lang'

  export default {
    name: 'commission-amount',
    locales,
    data() {
      return {
        monthTypeList: [1, 3, 12],
        deviceNumList: ['1', '2', '3', '5+'],
        amountList: null
      }
    },
    computed: {
      ...mapState({
        currentLang: 'currentLang'
      })
    },
    mounted() {
      const amountCNY = [[['￥3.12', '￥1.95'], ['￥7.92', '￥4.95'], ['￥23.92', '￥14.95']], [['￥4.72', '￥2.95'], ['￥12.72', '￥7.95'], ['￥39.92', '￥24.95']], [['￥7.04', '￥4.40'], ['￥19.04', '￥11.90'], ['￥59.84', '￥37.40']], [['￥11.68', '￥7.30'], ['￥31.68', '￥19.80'], ['￥99.68', '￥62.30']]]
      const amountUSD = [[['$0.48', '$0.30'], ['$1.12', '$0.70'], ['$3.44', '$2.15']], [['$0.72', '$0.45'], ['$1.84', '$1.15'], ['$5.76', '$3.60']], [['$1.04', '$0.65'], ['$2.72', '$1.70'], ['$8.56', '$5.35']], [['$1.68', '$1.05'], ['$4.48', '$2.80'], ['$14.24', '$8.90']]]

      this.amountList = this.currentLang === 'en' ? amountUSD : amountCNY
    }
  }
</script>

<style lang="scss">
  @import "../../../assets/scss/mixins/button";
  @import "../../../assets/scss/mixins/gradient";
  .commission-amount {
    margin: 180px 0;
    border: 1px solid #E0D7E3;
    border-radius: 8px;
    padding: 40px 40px 80px;
    h2 {
      margin: 0;
      font-size: 24px;
      color: #111111;
      line-height: 32px;
      font-weight: 600;
    }
    .little-title {
      margin: 11px 0 40px;
      font-size: 18px;
      color: #999999;
      line-height: 26px;
      text-align: center;
    }
    .amount-list {
      list-style: none;
      margin-bottom: .24rem;
      padding-left: 0;
      > li {
        display: flex;
        height: .54rem;
        line-height: .54rem;
        font-size: .24rem;
        color: #333;
        &.list-header {
          > div {
            font-weight: 600;
          }
        }
        &:nth-child(odd) {
          background: #F7F7F7;
        }
        > div {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          &.amount {
            > span {
              vertical-align: middle;
            }
            > span:nth-child(1) {
              color: #416CF8;
              width: .8rem;
              text-align: right;
            }
            > span:nth-child(2) {
              display: inline-block;
              width: 1px;
              height: .24rem;
              margin: .16rem;
              background: #D8D8D8;
            }
            > span:nth-child(3) {
              color: #EC55FF;
              width: .8rem;
              text-align: left;
            }
          }
        }
      }
    }
    .legend {
      display: flex;
      justify-content: flex-end;
      .first-purchase, .renew {
        padding-left: 8px;
        position: relative;
        font-size: .16rem;
        color: #333;
        line-height: 24px;
        &::after {
          display: block;
          content: '';
          width: .12rem;
          height: .12rem;
          border-radius: 50%;
          position: absolute;
          top: 50%;
          left: -.15rem;
          transform: translateY(-50%);
        }
      }
      .first-purchase {
        margin-right: .4rem;
      }
      .first-purchase::after {
        background: #416CF8;
      }
      .renew::after {
        background: #EC55FF;
      }
    }
    .amount-list-pc {
      display: block;
    }
    .amount-list-h5 {
      display: none;
    }
  }

  @media (max-width: 991px) {
    .commission-amount {
      margin: 40px 0 80px;
      border: none;
      padding: 0;
    }
  }

  @media (max-width: 820px) {
    .commission-amount {
      h2 {
        font-size: 24px;
        line-height: 32px;
      }
      .little-title {
        margin: 16px 0 0;
        font-size: 14px;
        line-height: 20px;
      }
      .legend {
        display: none;
      }
      .amount-list {
        margin: 41px 0 0;
        border: 1px solid #E0D7E3;
        border-radius: 5px;
        > li {
          height: 49px;
          line-height: 49px;
          font-size: 18px;
          > div.amount > span:nth-child(2) {
            height: 0.16rem;
            margin: 0.08rem;
          }
          &:first-child {
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
          }
          &:last-child {
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
          }
        }
      }
      .amount-list-pc {
        display: none;
      }
      .amount-list-h5 {
        display: block;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// commissionAmount.vue?56a5ebbb